<input (change)="onFileChange($event)" multiple="multiple" type="file"/>
<table class="sjs-table">
  <tbody>
  <tr *ngFor="let row of data">
    <td *ngFor="let val of row">
      {{ val }}
    </td>
  </tr>
  </tbody>
</table>
<button (click)="export()">Export!</button>
